<template>
    <slot name="main">
        <div class="overlay" :style="{ opacity: opacity }" @click="hide">
            <div :class="isError ? 'infobox error' : 'infobox message'" @click.stop>
                <div class="title">{{ title }}</div>
                <div class="text">{{ text }}</div>
                <div
                    v-if="allowCopy"
                    class="copy-button"
                    @click="() => this.copyTextToCliboard(this.text)"
                >
                    <span class="icon-content_copy" />
                </div>
                <button
                    class="button"
                    v-if="!isCompliant && $t('home.copyUrl').length"
                    @click="() => this.copyTextToCliboard(document.location.href)"
                >
                    {{ $t("home.copyUrl") }}
                </button>
                <slot name="actions"></slot>
            </div>
        </div>
    </slot>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "Message",
    props: {
        isError: Boolean,
        title: String,
        text: String,
        allowCopy: {
            type: Boolean,
            default: false
        },
        isCompliant: Boolean
    },
    emits: ["close"],
    data() {
        return {
            opacity: 0
        };
    },
    mounted() {
        this.opacity = 1;
    },

    methods: {
        hide() {
            this.opacitty = 0;
            window.setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
        copyTextToCliboard(text: string) {
            console.log("copy text to clipboard");
            const copyText = document.createElement("textarea");
            document.body.appendChild(copyText);
            copyText.value = text;
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            document.execCommand("copy");
            document.body.removeChild(copyText);
        }
    }
});
</script>

<style scoped>
.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(1, 1, 1, 0.5);
    transition-duration: 0.5s;
    z-index: 999;
}

.infobox {
    position: fixed;
    width: 70vw;
    min-height: 40vw;
    left: calc(50vw - 35vw);
    top: calc(50vh - 20vw);
    background-color: var(--white);
    border-radius: 10px;
    box-shadow: 3px 3px 1px 1px rgba(255, 255, 255, 0.1);
}

.message .title {
    height: 50px;
    font-size: 1.2em;
    font-weight: 700;
    background-color: transparent;
    color: black;
}

.error .title {
    background-color: #e80f0f;
}

.title {
    line-height: 60px;
    border-radius: 10px 10px 0 0;
    width: 100%;
    height: 60px;
    color: var(--white);
}

.text {
    padding: 5px;
    width: calc(100% - 10px);
}

.message .text {
    line-height: 18px;
}

.button {
    margin: 5px;
    background-color: #004d7e;
    color: var(--white);
    border: none;
    border-radius: 5px;
}

.copy-button {
    cursor: pointer;
    margin: 10px 0;
    font-weight: bold;
    font-size: 1.5em;
}
</style>
